import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { usePsfPromoteOrSharePageState } from '#src/app/pages/psf/promoteOrShare/pageContext';

import { useAvailablePaymentMethods, useMoreWaysExpanded, usePromoteFormState } from '../../../../formContext';

type Result = ModelHookResult<
	{
		moreWaysExpanded: boolean;
		stripeWalletPaymentsEnabled: boolean;
	},
	{
		clickMoreWays: () => void;
	}
>;

export function usePaymentMethods(): Result {
	const [, { setMoreWaysExpanded: setPageMoreWaysExpanded }] = usePsfPromoteOrSharePageState();
	const { paymentMethods } = useAvailablePaymentMethods();
	const [, { setMoreWaysExpanded }] = usePromoteFormState();
	const moreWaysExpanded = useMoreWaysExpanded();
	const track = useTracking();

	const clickMoreWays = useCallback(() => {
		void track('pp_click_more_ways');
		setMoreWaysExpanded(true);
		// Keeping form state in sync with page state to prevent errors.
		setPageMoreWaysExpanded(true);
	}, [setMoreWaysExpanded, setPageMoreWaysExpanded, track]);

	const stripeWalletPaymentsEnabled = paymentMethods.includes('applePay') || paymentMethods.includes('googlePay');

	return {
		data: {
			stripeWalletPaymentsEnabled,
			moreWaysExpanded,
		},
		actions: {
			clickMoreWays,
		},
	};
}
